import { BLACK_a } from "baseStyles";
import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Wrapper = styled.div`
  margin-top: 11.2rem;

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin-top: 10rem;
  }
`;

export const InputWrapper = styled.div`
  margin: 0 auto;
  width: 59rem;
  height: 6rem;

  border: 1px solid #363636;
  border-radius: 4rem;
  display: flex;
  align-items: center;
  & > img {
    width: 3.6rem;
    height: 3.6rem;
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 33.5rem;
    height: 5rem;
    & > img {
      width: 2.8rem;
      height: 2.8rem;
    }
  }
`;

export const Input = styled.input`
  width: 53.9rem;
  height: 100%;
  box-sizing: border-box;
  border-top-left-radius: 4rem;
  border-bottom-left-radius: 4rem;
  background-color: transparent;
  border: none;
  padding-left: 3rem;
  font-weight: 300;
  font-size: 1.6rem;
  color: ${BLACK_a};
  line-height: 2.8rem;
  outline: none;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 28.7rem;
  }
`;
